/**
 wrapper clicky so that we don't break when user's AdBlock blocks 
 the clicky script
*/
export function log(url: string, message?: string) {
    try {
        clicky.log(url, message);
    } catch (ex) {
        // ignore all failures
    }
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/clacky.ts